/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const bookingStatusSchema = z.enum(['confirmed', 'cancelled'])

export type BookingStatusSchema = z.infer<typeof bookingStatusSchema>
